import * as React from 'react';
import { Button, Box, AlertBox } from '@origin-digital/style-guide';
import { PasswordInput } from '../PasswordInput/PasswordInput';
import { HiddenAutofillInput } from '../HiddenAutofillInput/HiddenAutofillInput';
import styled from 'styled-components';
import Loader from '../Loader';
import { IError } from 'ts/login/interfaces';

interface QuickLoginFormViewProps {
  username: string;
  password: string;
  loginError: IError;
  loginSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  passwordError: string;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
}

const QuickLoginFormView: React.FC<QuickLoginFormViewProps> = ({
  loading,
  username,
  password,
  loginError,
  loginSubmit,
  passwordError,
  onPasswordChange,
}) => {
  return (
    <>
      {loading ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <>
          {loginError && (
            <Box marginBottom={8}>
              <AlertBox
                type="error"
                heading={loginError.heading}
                message={loginError.body}
                markdown={true}
              />
            </Box>
          )}
          <form onSubmit={loginSubmit}>
            <HiddenAutofillInput username={username} />
            <PasswordInput
              label={'Password'}
              value={password}
              error={passwordError}
              onChange={onPasswordChange}
            />
            <Button type="submit" data-id="login" text="Log in" name="login" block={true} />
          </form>
        </>
      )}
    </>
  );
};

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

export { QuickLoginFormView, LoaderWrapper };
